export default __webpack_public_path__ + "media/resources3.4ce2dc0a.png";